import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { GUI } from './gui';
import { LocalStorage } from './local-storage';
import { Tags } from './tags';
import { Utils } from './utils';
import { MemoryStorage } from './memory-storage';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {

    constructor(protected readonly router: Router, private browserStorageService: MemoryStorage, protected readonly keycloak: KeycloakService, private localStorage: LocalStorage, private tags: Tags, private utils: Utils, private gui: GUI) {
        super(router, keycloak);
    }

    public async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // if (!this.authenticated) {
        //     await this.keycloak.login({
        //         redirectUri: window.location.origin + state.url,
        //     });
        //     return false;
        // }


        const keycloakToken = this.browserStorageService.get(this.tags.KEYCLOAK_TOKEN) || this.keycloak.getKeycloakInstance().token;
        const keycloakRefreshToken = this.browserStorageService.get(this.tags.KEYCLOAK_REFRESH_TOKEN) || this.keycloak.getKeycloakInstance().refreshToken;
        const loggedUserId = this.browserStorageService.get(this.tags.LOGGED_USER_ID);


        if (this.utils.isEmpty(keycloakToken) === true || this.utils.isEmpty(keycloakRefreshToken) === true || this.utils.isEmpty(loggedUserId) === true) {
            this.gui.openLogoutPage();
            return false;
        }

        const requiredRoles = route.data.roles;

        if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
            return true;
        }

        return requiredRoles.every((role) => this.roles.includes(role));
    }

}
